// Create a new utility file for permissions
const hasManagerAccess = (user) => {
  return user?.is_admin ||
         user?.is_super_manager ||
         user?.is_account_manager ||
         user?.is_manager;
};

// Get the role level of a user (higher number = higher role)
const getRoleLevel = (user) => {
  if (!user) return 0;
  if (user.is_admin) return 5;
  if (user.is_super_manager) return 4;
  if (user.is_account_manager) return 3;
  if (user.is_manager) return 2;
  if (user.is_yard_driver || user.is_road_driver || user.is_mechanic || user.is_security) return 1;
  return 0; // Regular user
};

// Check if currentUser can modify targetUser (delete, edit, etc.)
const canModifyUser = (currentUser, targetUser, operation = 'update') => {
  if (!currentUser || !targetUser) return false;

  // Users can update their own account, but cannot delete it
  if (currentUser.id === targetUser.id) {
    return operation === 'update';
  }

  // Check role hierarchy
  const currentUserLevel = getRoleLevel(currentUser);
  const targetUserLevel = getRoleLevel(targetUser);

  // User can only modify users with lower role levels
  return currentUserLevel > targetUserLevel;
};

export { hasManagerAccess, getRoleLevel, canModifyUser };
